import React, { useEffect } from "react";
import { HeaderMenu, LeftMenu } from "../Component/Template";
import { GetCookieV2 } from "../Utils";
import { Outlet } from 'react-router-dom';

export const LayoutMain = () => {
  useEffect(() => {
    let check = GetCookieV2("All");
    if (check === null || check === undefined || check === "")
      window.location.href = "/";
  }, []);
  return (
    <>
      <LeftMenu></LeftMenu>
      <div className="main-panel ps">
        <HeaderMenu></HeaderMenu>
        <div className="content" style={{ height: "calc(100vh - 58px)" }}>
         <Outlet />
        </div>
        {/* <FooterMenu></FooterMenu> */}
      </div>
    </>
  );
};